import { ThemeColors } from "../types";
import { palette } from "./palette";

/**
 * Dark theme tokens.
 *
 * There is no existing dark appearance in the Lighthouse app to match, so
 * these are new, deliberately chosen values following common dark-surface
 * conventions (elevated surfaces get progressively lighter, brand blue is
 * lightened slightly for contrast). Status colors (success/warning/error)
 * are intentionally kept identical to Light mode for now to avoid
 * introducing new semantic meaning — this can be revisited later if needed.
 */
export const darkThemeColors: ThemeColors = {
  background: {
    page: palette.almostBlack,
    surface: palette.darkSurface,
    elevated: palette.darkElevated,
  },
  text: {
    primary: palette.darkTextPrimary,
    secondary: palette.darkTextSecondary,
    disabled: palette.darkTextDisabled,
    inverse: palette.white,
  },
  border: {
    default: palette.darkBorder,
    divider: palette.darkDivider,
  },
  brand: {
    primary: palette.darkBrandBlue,
  },
  input: {
    background: palette.darkSurface,
    border: palette.darkInputBorder,
  },
  button: {
    primaryBackground: palette.darkBrandBlue,
    primaryText: palette.white,
    secondaryBackground: palette.darkSurface,
    secondaryText: palette.darkBrandBlue,
    disabledBackground: palette.darkElevated,
    disabledText: palette.darkTextDisabled,
  },
  status: {
    success: palette.green400,
    warning: palette.amber,
    error: palette.red700,
    info: palette.darkBrandBlue,
  },
  statusBackground: {
    info: palette.infoBgDark,
    success: palette.successBgDark,
    warning: palette.warningBgDark,
    error: palette.errorBgDark,
  },
  overlay: palette.overlayDark,
  // Reuses the existing dark error surface/border tokens (same values as
  // `status.error` / `statusBackground.error` above) rather than inventing
  // new ones, per the selected-card dark-mode spec. Text uses the app's
  // established readable dark-mode error-text red for sufficient contrast
  // against the dark error background.
  cardSelected: {
    border: palette.red700,
    background: palette.errorBgDark,
    text: palette.darkErrorText,
  },
};
